import Focus from '../../../../shared/types/enums/focus';
import Item from '../../atoms/text/menuItem';
import ListContext from '../../../../shared/components/utils/context/listContext';
import { MenuItemProps as Props } from '../../../../shared/types/props/menu';
import { focusSelector } from '../../../../shared/store/slices/focus.slice';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useAppSelector } from '../../../../shared/store/hooks';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';

function MenuItem({ children, index, enterAction, focusAction }: Props) {
  const { focus } = useAppSelector(focusSelector);
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { listIndex, setListIndex } = useContext(ListContext);
  const [focused, setFocused] = useState(false);

  // Event handlers

  const onClick = useCallback(() => {
    if (index !== undefined) {
      setListIndex(index);
      index === listIndex ? enterAction(index) : focusAction(index);
    }
  }, [index, listIndex]);

  const onPointerEnter = () => {
    setFocused(true);
  };

  const onPointerLeave = () => {
    setFocused(index === listIndex);
  };

  // Effect hooks

  useEffect(() => {
    const focused = index === listIndex;
    setFocused(focused);
  }, [listIndex, enabled]);

  return (
    <>
      <Item
        animation={focused ? 'menu-item-in' : 'menu-item-out'}
        force={true}
        focused={focused && focus === Focus.MENU}
        index={index}
        onClick={onClick}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
      >
        {children}
      </Item>
    </>
  );
}

export default MenuItem;
